var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.5 35.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.28,12.16a11.9,11.9,0,1,0,11.9,11.9A11.92,11.92,0,0,0,17.28,12.16Zm0,22.79a10.9,10.9,0,1,1,10.9-10.89A10.9,10.9,0,0,1,17.28,35Zm6.84-13.67H19.87L17.73,17a.51.51,0,0,0-.9,0l-2.14,4.29H10.44a.5.5,0,0,0-.47.33.5.5,0,0,0,.16.56L13.67,25l-1.43,5a.49.49,0,0,0,.18.53.5.5,0,0,0,.57,0l4.29-2.69,4.3,2.69a.48.48,0,0,0,.26.07.5.5,0,0,0,.48-.63l-1.43-5,3.54-2.83a.5.5,0,0,0,.16-.56A.5.5,0,0,0,24.12,21.28ZM20,24.42a.5.5,0,0,0-.17.53L21,29l-3.45-2.16a.51.51,0,0,0-.53,0L13.56,29,14.72,25a.5.5,0,0,0-.17-.53l-2.68-2.14H15a.51.51,0,0,0,.45-.28l1.83-3.67L19.11,22a.51.51,0,0,0,.45.28h3.13ZM34.45.72l-6.1,12.69a.49.49,0,0,1-.45.29.54.54,0,0,1-.21,0,.5.5,0,0,1-.24-.67L33.2,1H30.52L25.63,11.31a.42.42,0,0,1-.17.18.1.1,0,0,1-.05,0,.46.46,0,0,1-.2.05h0a.35.35,0,0,1-.2-.05.49.49,0,0,1-.24-.66L29.41,1H26.72L22.5,9.85a.5.5,0,0,1-.9-.43L26,.29A.49.49,0,0,1,26.4,0H34a.5.5,0,0,1,.42.23A.53.53,0,0,1,34.45.72ZM6.14,13.41.05.72A.5.5,0,0,1,.5,0H8.1a.49.49,0,0,1,.45.29L12.9,9.42a.5.5,0,0,1-.9.43L7.78,1H5.09l4.68,9.88a.5.5,0,0,1-.44.71H9.28a.41.41,0,0,1-.19-.05l-.06,0a.49.49,0,0,1-.17-.18L4,1H1.29L7,13a.5.5,0,0,1-.23.67.54.54,0,0,1-.22,0A.51.51,0,0,1,6.14,13.41Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.2fecf8543c80a2fbe362cf12391ce1eb.svg";
export { ForwardRef as ReactComponent };